import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-on-boarding-setup-induction-question',
  templateUrl: './on-boarding-setup-induction-question.component.html',
  styleUrls: ['./on-boarding-setup-induction-question.component.css']
})
export class OnBoardingSetupInductionQuestionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
